// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Module,
    ModuleFromJSON,
    ModuleToJSON,
} from '../models';

export interface ReadRequest {
    id: string;
    curriculum?: string;
    subject?: string;
    grade?: string;
    version?: string;
    maxAssetsPerSlab?: number;
}

/**
 * no description
 */
export class ModulesApi extends runtime.BaseAPI {

    /**
     * Return module detail
     */
    async readRaw(requestParameters: ReadRequest): Promise<runtime.ApiResponse<Module>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling read.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.curriculum !== undefined) {
            queryParameters['curriculum'] = requestParameters.curriculum;
        }

        if (requestParameters.subject !== undefined) {
            queryParameters['subject'] = requestParameters.subject;
        }

        if (requestParameters.grade !== undefined) {
            queryParameters['grade'] = requestParameters.grade;
        }

        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }

        if (requestParameters.maxAssetsPerSlab !== undefined) {
            queryParameters['max_assets_per_slab'] = requestParameters.maxAssetsPerSlab;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/modules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ModuleFromJSON(jsonValue));
    }

    /**
     * Return module detail
     */
    async read(requestParameters: ReadRequest): Promise<Module> {
        const response = await this.readRaw(requestParameters);
        return await response.value();
    }

}
